import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';
import iconFive from '../../assets/service/5.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Thoái hóa khớp',
        'description': 'Điều trị hiệu quả tình trạng thoái hóa khớp, giúp giảm đau, giảm cứng khớp và cải thiện vận động.'
    },
    {
        'icon': iconTwo,
        'title': 'Viêm khớp dạng thấp',
        'description': 'Kiểm soát hiệu quả tình trạng viêm khớp mạn tính, giúp giảm đau, hạn chế biến dạng và bảo vệ chức năng khớp.'
    },
    {
        'icon': iconThree,
        'title': 'Phẫu thuật thay khớp háng, khớp gối ',
        'description': 'Điều trị hiệu quả tổn thương khớp nặng, giúp giảm đau, cải thiện vận động và phục hồi khả năng đi lại.'
    },
    {
        'icon': iconFour,
        'title': 'Chấn thương chỉnh hình',
        'description': 'Điều trị hiệu quả các chấn thương xương khớp, giúp giảm đau, phục hồi chức năng và vận động linh hoạt.'
    },
    {
        'icon': iconFive,
        'title': 'Một số bệnh lý khác',
        'description': 'Thăm khám và điều trị nhiều bệnh lý cơ xương khớp khác như Nội soi khớp, Thoát vị đĩa đệm, Gai cột sống, Viêm gân, viêm bao hoạt dịch, Hội chứng ống cổ tay, Đau thần kinh tọa,...'
    }
]

export default ServicesData;